import AIChat from "../../model2/ai/chat/chat";
import AIChatContext from "../../model2/ai/chat/context/context";
import {AIChatContextType, AIChatProvider} from "../../model2/ai/@const";
import AIChatMessage from "../../model2/ai/chat-message/chat-message";

export const AI_CHAT_AGENT_CHANGED  = 'ai-chat-agent:changed'
export const AI_CHAT_LAST_AGENT_KEY = 'gd.aiChat.lastAgentId'

// const debug = "AiChatModule"
const debug = false

export default class AiChatModule {

    public chatDebugEnabled : boolean = false

    public _currentAIChat       : AIChat | null
    public _currentAiMessage    : AIChatMessage | null = null
    public _aiChats             : AIChat[]
    public _chatContext         : AIChatContext | null
    public _provider            : AIChatProvider
    public _agentId             : ID | null

    constructor() {

        this._currentAIChat     = null
        this._currentAiMessage  = null
        this._aiChats           = []
        this._chatContext    = new AIChatContext({
            type: AIChatContextType.ALL_SPACES,
            taskId: null
        })
        this._provider          = _.get(this.currentAIChat, "provider", AIChatProvider.GPT_4o_MINI)
        this._agentId           = localStorage.getItem(AI_CHAT_LAST_AGENT_KEY) || null
    }

    get canSendMessage() {
        const result =
            !!this.currentAIChat
            || !!this.chatContext?.taskId
            || !!this.chatContext?.projectId
            || this.chatContext?.type === AIChatContextType.ALL_SPACES

        debug && console.log(debug, "canSendMessage", result)
        return result
    }

    get currentAIChat (): AIChat | null {
        return this._currentAIChat
    }

    set currentAIChat (chat: AIChat | null) {
        this._currentAIChat = chat
    }

    get currentAiMessage (): AIChatMessage | null {
        return this._currentAiMessage
    }

    set currentAiMessage (chatMessage: AIChatMessage | null) {
        this._currentAiMessage = chatMessage
    }

    get chatContext (): AIChatContext | null {
        return this._chatContext
    }

    set chatContext (context: AIChatContext | null) {
        // console.log("newChatContext ", context)
        this._chatContext = context
    }

    get provider (): AIChatProvider {
        return this._provider
    }

    set provider (value: AIChatProvider) {
        this._provider = value
    }

    get agentId (): ID | null {
        if (this.currentAIChat) return this.currentAIChat.agentId
        return this._agentId
    }

    set agentId (value: ID | null) {
        this._agentId = value
        if (value !== null) {
            localStorage.setItem(AI_CHAT_LAST_AGENT_KEY, value)
        } else {
            localStorage.removeItem(AI_CHAT_LAST_AGENT_KEY)
        }
        if (this.currentAIChat) {
            this.currentAIChat.agentId = value
        }
        gd.bus.triggerEvent(AI_CHAT_AGENT_CHANGED)
    }

}